import { combineReducers } from "redux";
import mainReducer from "@/bit/reducers/reducers.main-reducer";
import modalsReducer from "@/bit/reducers/reducers.modals-reducer";
import headerReducer from "@/bit/reducers/reducers.header-reducer";
import userReducer from "@/reducers/user";
import orionReducer from "@/reducers/orion";
import managerReducer from "@/reducers/manager";
import clientReducer from "@/reducers/client";
import initPage from "@/reducers/initPage";
import productReducer from "@/reducers/product";
import UsagesReducer from "./usages";
import catalogueReducer from "@/reducers/catalogue";
import tvReducer from "@/reducers/tv";
import thirdPartiesReducer from "@/reducers/thirdParties";
import billsReducer from "@/reducers/bills";
import generalManagmentReducer from "@/reducers/general-managment";
import pageReducer from "@/reducers/page";
import notificationsReducer from "@/reducers/notifications";
import cqReducer from "@/reducers/cq";
import trackingReducer from "@/reducers/tracking";
import breakdownReducer from "@/reducers/breakdown";
import contractsReducer from "@/reducers/contracts";
import selfDiagnosisReducer from "@/reducers/selfDiagnosis";
import consentsReducer from "@/reducers/consents";

import prepaidReducer from "@/reducers/prepaid";
import miscellanyReducer from "@/reducers/miscellany";
import oneClick from "@/reducers/oneClick";
import address from "@/reducers/address"

import deviceList from "@/reducers/device-list";
import cerberusReducer from "@/reducers/cerberus";

const REDUCERS_LIST = {
  main: mainReducer,
  user: userReducer,
  page: pageReducer,
  modals: modalsReducer,
  header: headerReducer,
  orion: orionReducer,
  manager: managerReducer,
  client: clientReducer,
  initPage,
  usages: UsagesReducer,
  product: productReducer,
  catalogue: catalogueReducer,
  tv: tvReducer,
  thirdParties: thirdPartiesReducer,
  bills: billsReducer,
  generalManagment: generalManagmentReducer,
  notifications: notificationsReducer,
  cq: cqReducer,
  tracking: trackingReducer,
  breakdown: breakdownReducer,
  contracts: contractsReducer,
  selfDiagnosis: selfDiagnosisReducer,
  prepaid: prepaidReducer,
  miscellany: miscellanyReducer,
  oneClick: oneClick,
  deviceList: deviceList,
  address: address,
  consents: consentsReducer,
  cerberus: cerberusReducer,
};

const rootReducers = () =>
  combineReducers({
    ...REDUCERS_LIST,
  });

export default rootReducers;
